module.exports = __webpack_public_path__ + "img/488b8d7.png";